import axios, { AxiosError, AxiosResponse } from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from 'constants/index';
import { useState } from 'react';

const useReceivePackage = () => {
  const [isPosting, setIsPosting] = useState(false);

  const post = async (id) => {
    setIsPosting(true);
    const result = await axios
      .put(`${API_BASE_URL}/users/consignments/${id}/done`, null, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
        },
      })
      .then((res) => {
        const responseData = res.data;
        if (responseData.status_code !== 200) {
          return {
            isSuccess: false,
            message: responseData.message,
            data: responseData.data,
          };
        }

        return {
          isSuccess: true,
          message: responseData.message,
          data: responseData.data,
        };
      })
      .catch((err: AxiosError) => {
        const responseError = err.response?.data?.error;

        return {
          isSuccess: false,
          message:
            responseError?.message ||
            'Aksi gagal dilakukan, Silahkan coba kembali atau kontak CS kami',
          data: null,
        };
      });

    setIsPosting(false);

    return result;
  };

  return {
    isPosting,
    post,
  };
};

export default useReceivePackage;
